import {
  updateCustomReferences,
  getReferences,
  deleteReferences
} from "@/common/service/apiaggregator/manifestAgreegatorService";

const state = {
  referencesList: [],
  complianceReferences: {},
  referencesListLoader: false,
  updateReferenceLoader: false,
  deleteReferenceLoader: false,
  firstEventLinkedDate: null,
  referencesListError: null,
  updateReferenceError: null,
  deleteReferenceError: null,
  compId: "",
  complianceType: "",
  activeBox: ""
};

const mutations = {
  setReferencesList(state, result) {
    state.referencesList = result;
  },
  setActiveBox(state, result) {
    state.activeBox = result;
  },
  setFirstEventLinkedDate(state, result) {
    state.firstEventLinkedDate = result;
  },
  setComplianceReferencesList(state, result) {
    state.complianceReferences = result;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "hasError" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },
  setComplianceId(state, value) {
    state.compId = value;
  },
  setComplianceType(state, value) {
    state.complianceType = value;
  }
};

const actions = {
  async fetchReferences({ commit }, { params, compliances = {} } = {}) {
    commit("setReferencesList", []);
    commit("setLoadingState", { type: "referencesList", value: true });
    try {
      let rawData,
        data = [];

      rawData = await getReferences(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "referencesList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      if (params.firstEventLinkedDate) {
        commit("setFirstEventLinkedDate", params.firstEventLinkedDate);
      }
      if (data.bolManifestReference) {
        let references = data.bolManifestReference.references || [];

        if (compliances.complianceName === "US Advance Manifest" && compliances.moveType === "FROB") {
          references = references.filter(reference => reference.type !== "INBOND");
        }

        commit("setReferencesList", {
          ...data.bolManifestReference,
          references
        });
      }
      if (data.complianceManifestReference) {
        commit("setComplianceReferencesList", data.complianceManifestReference);
      }
      commit("setErrorState", { type: "referencesList", error: "" });
      commit("setLoadingState", { type: "referencesList", value: false });
    } catch (error) {
      commit("setReferencesList", []);
      commit("setErrorState", { type: "referencesList", error });
      commit("setLoadingState", { type: "referencesList", value: false });
    }
  },
  async updateCustomReference({ commit, dispatch, rootState }, params) {
    commit("setLoadingState", { type: "updateReference", value: true });
    try {
      const { req_body, type } = params;
      req_body.firstEventLinkedDate = state.firstEventLinkedDate || "";
      req_body.userName = rootState.userAccount.loginDetails.name;
      req_body.userId = rootState.userAccount.loginDetails.idTokenClaims.MaerskID;
      let rawData;
      rawData = await updateCustomReferences(req_body, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "updateCargo",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }

      const tempParam = {
        bolNumber: req_body.bolId,
        complianceId: req_body.complianceId,
        complianceType: req_body.complianceType,
        compliancePort: req_body.compliancePort,
        consignmentType: req_body.consignmentType || "BOL",
        masterBolNumber: req_body.masterBolNumber || ""
      };
      if (type !== "crn") {
        dispatch("fetchReferences", { params: tempParam });
      }
      commit("setErrorState", { type: "updateReference", error: "" });
      commit("setLoadingState", { type: "updateReference", value: false });

      if (rawData.status > 200 && rawData.status <= 299) {
        return false;
      } else {
        return rawData;
      }
    } catch (error) {
      commit("setErrorState", { type: "updateReference", error });
      commit("setLoadingState", { type: "updateReference", value: false });
      return false;
    }
  },
  async deleteCustomReferences({ commit, dispatch }, qParams) {
    commit("setLoadingState", { type: "deleteReference", value: true });
    try {
      let rawData;
      qParams.firstEventLinkedDate = state.firstEventLinkedDate || "";
      rawData = await deleteReferences(qParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "updateCargo",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }

      const tempParam = {
        bolNumber: qParams.bolNumber,
        complianceId: qParams.complianceId,
        complianceType: qParams.complianceType,
        compliancePort: qParams.compliancePort,
        consignmentType: qParams.consignmentType || "BOL",
        masterBolNumber: qParams.masterBolNumber || ""
      };
      dispatch("fetchReferences", { params: tempParam });
      commit("setErrorState", { type: "deleteReference", error: "" });
      commit("setLoadingState", { type: "deleteReference", value: false });
    } catch (error) {
      commit("setErrorState", { type: "deleteReference", error });
      commit("setLoadingState", { type: "deleteReference", value: false });
    }
  },
  refreshBOLComplianceData({ dispatch }, params) {
    const { bolNumber, type } = params;
    if (type === "bol") {
      dispatch("bolDetails/fetchBolDetails", bolNumber, { root: true });
    } else {
      dispatch(
        "manifestModule/filterModule/filterComplianceDetailsList",
        {
          consignmentType: "BOL"
        },
        { root: true }
      );
      dispatch(
        "manifestModule/filterModule/filterComplianceDetailsList",
        {
          consignmentType: "CONTAINER"
        },
        { root: true }
      );
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
